import FetchService from './base.fetch';
// import AjaxService from './base.ajax';
import CONSTANT from '../../constant';
import Config from '../../config';

/**
 * 数据服务
 *
 * @export
 * @class UserService
 */
class UserService {

    /**
     * Creates an instance of UserService.
     * @memberof UserService
     */
    constructor() {
        this.domain = FetchService.domainconfig.passport2;
        const header = {
            'clientdevice': `system/${window.navigator.userAgent};version/${Config.appVersion}`
        };
        const apisConfig = {
            // 获取重置密码验证码
            get_findpwd_code: {
                method: 'post',
                url: 'v1/code/findpwd',
                header
            },
            // 注册
            register: {
                method: 'post',
                url: 'v1/user/emailregisternocode',
                header
            },
            // 登录
            login: {
                method: 'post',
                url: 'v1/user/login',
                header
            },
            // 注销
            logout: {
                method: 'post',
                url: 'v1/user/logout',
                header
            },
            // 重置密码
            resetpwd: {
                method: 'post',
                url: 'v1/email/resetpwd',
                header
            },
            // 检查 用户登录状态
            get_account: {
                method: 'post',
                url: 'v1/user/getbyutoken',
                redirectLogin: false,
                header
            },
            // 获取跳转云数据站点 token
            geturltoken: {
                method: 'post',
                url: 'v1/user/geturltoken',
                header
            },
            // 检查邮箱或学生号是否已注册
            check_account: {
                method: 'post',
                url: 'v1/account/check',
                header
            },
            // 修改密码
            updatepwd: {
                method: 'post',
                url: 'v1/account/changepwd',
                header
            },
            // 检查找回密码验证码是否正确
            check_validCode: {
                method: 'post',
                url: 'v1/code/findpwd/check',
                header
            },
            // 检查旧密码是否正确
            check_oldPwd: {
                method: 'post',
                url: 'v1/account/checkpwd',
                header
            },
            // 删除帐号
            delete_account: {
                method: 'post',
                url: 'v1/user/drop',
                header
            },
            accesstoken: {
                method: 'post',
                url: 'v1/api/getaccesstoken',
                header
            }
        };

        this.saveUserInfo = (data) => {
            if (data.token) {
                FetchService.store.set(CONSTANT.USER_ACCESS_TOKEN_KEY, data.token);
            }
            if (data.user) {
                FetchService.store.set(CONSTANT.USER_INFO_KEY, data.user);
            }
        };

        FetchService.configToRequestAction.call(this, apisConfig, FetchService);
    }

    saveUserInfoToLocal(data) {
        if (data.token) {
            FetchService.store.set(CONSTANT.USER_ACCESS_TOKEN_KEY, data.token);
        }
        if (data.user) {
            FetchService.store.set(CONSTANT.USER_INFO_KEY, data.user);
        }
    }

    removeUserinfoToLocal() {
        FetchService.store.remove(CONSTANT.USER_INFO_KEY);
        FetchService.store.remove(CONSTANT.USER_ACCESS_TOKEN_KEY);
    }

    getUserInfoToLocal() {
        const data = FetchService.store.get(CONSTANT.USER_INFO_KEY);
        const token = FetchService.store.get(CONSTANT.USER_ACCESS_TOKEN_KEY);
        return {
            data: {
                data,
                token,
                isLogin: Boolean(token && data)
            }
        };
    }

    getUserToken() {
        return FetchService.store.get(CONSTANT.USER_ACCESS_UTOKEN_KEY) || FetchService.store.get(CONSTANT.USER_ACCESS_TOKEN_KEY);
    }

}

export default new UserService();